import { Box3, Object3D } from 'three';
import { Door, Handle } from '../domain';
import { getGeometrySize } from '../geometry';
import logging from '../logging';
import { clamp } from '../math/clamp';

const log = logging('doorControllers');

const box = new Box3();

export const setHandleDirection = (handle: Handle, obj: Object3D, direction: 'h' | 'v', flip?: 'r') => {

    if(handle.assetId) {
        if(direction = 'v') {
            handle.rotation.z = -Math.PI/2;

            if(obj) getGeometrySize(obj, box);
            const
                width = box.max.x - box.min.x,
                height = box.max.y - box.min.y;
            if(width > 0 && width/height > 1.5) {
                obj.position.x = -width/2;
            } else if(width == 0) {
                log.error("doorControllers setHandleDirection: handle appears to have zero width; likely a loading problem");
            }
        }
        if(flip == 'r') {
            handle.scale.y = -1;
        }
    } else {
        let style: string;
        if(direction == 'h') {
            style = handle.style.replace(/^d-v/, 'd-h');
        } else {
            style = handle.style.replace(/^d-h/, 'd-v');
        }

        const ext = style.slice(-3); // expected obj or glb

        style = style.replace(/r?.(glb|obj)$/, '');
        if(flip == 'r') {
            handle.style = style + `r.${ext}`;
        } else {
            handle.style = style + `.${ext}`;
        }
    }
}

const IDEAL = 42;

/**
 * This only works for Doors with left and right hinges. If called on a drawer
 * or a top- or bottom-hinged door, you will not get the right appearance.
 */
export const setHandleHeight = (elevation: number, handle: Handle, height: number) => {
    const
        door = handle.parent as Door,
        min = 2,
        max = door.height - 2 - (height > 2 ? height : 0);

    handle.position.y = clamp(IDEAL - elevation, min, max);
}

